import { z } from 'zod';
import { isMongoId } from '../../helpers';
import { Api, DeliveryType } from 'further-types/custom-updates';
import { InvestmentCustomTagCategory } from 'further-types/investment';
import { InvestorCustomTagCategory } from 'further-types/investor';

const investmentCustomTag = z.object({
  category: z.nativeEnum(InvestmentCustomTagCategory),
  tag: z.string(),
});

const investorCustomTag = z.object({
  category: z.nativeEnum(InvestorCustomTagCategory),
  tag: z.string(),
});

const baseInput = {
  firmId: z.string().refine(isMongoId()),
  companyId: z.array(z.string()).default([]),
  trancheId: z.array(z.string()).default([]),
  investorIds: z.array(z.string()).default([]),
  allocationIds: z.array(z.string()).default([]),
  sendToDirectInvestors: z.boolean(),
  sendToAdvisedInvestors: z.boolean(),
  sendToAdvisers: z.boolean(),
  sendToOrganisations: z.boolean(),
  sendToAllUsers: z.boolean(),
  sendToAllUsersWithSubscriptions: z.boolean(),
  sendToAllUsersWithNoSubscriptions: z.boolean(),
  deliveryToInvestors: z.nativeEnum(DeliveryType),
};

export const GetRecipientsToSendUpdateInput = z.discriminatedUnion(
  'recipientFilter',
  [
    z.object({
      ...baseInput,
      recipientFilter: z.literal(Api.RecipientFilter.SubscriptionCustomTags),
      customTags: z.array(investmentCustomTag).default([]),
    }),
    z.object({
      ...baseInput,
      recipientFilter: z.literal(Api.RecipientFilter.InvestorCustomTags),
      customTags: z.array(investorCustomTag).default([]),
    }),
    z.object({
      ...baseInput,
      recipientFilter: z.enum([
        Api.RecipientFilter.Company,
        Api.RecipientFilter.Tranche,
        Api.RecipientFilter.Specific,
        Api.RecipientFilter.Subscriptions,
        Api.RecipientFilter.NoSubscriptions,
        Api.RecipientFilter.All,
      ]),
      customTags: z.array(z.never()).default([]),
    }),
  ],
);
